import React from "react";
import ReactDOM from "react-dom/client"; // 변경된 부분
import App from "./App";
import './index.css'; // TailwindCSS 및 전역 스타일을 불러옴

//document.title = "PocketMemory"; // 이 부분에서 제목을 설정

// React 18에 맞는 방식으로 수정
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
